// extracted by mini-css-extract-plugin
module.exports = {"icon":"profile-menu_icon__SK8FJ","text":"profile-menu_text__4dwUc","activeText":"profile-menu_activeText__NByuV","arrow":"profile-menu_arrow__3wYcs"};